import React from 'react'
import Manager from '../../public/components/Manager'
import BatchSpecialLeaveDetail from './BatchSpecialLeaveDetail'
Ext.require('Ext.Toast')

const config = props => {
    return {
        buttons: [
        ],
        columns: [
            { _text: '记录编号', field: 'Number', minWidth: 150, search: true, flex: 1, },
            { _text: '记录名称', field: 'Name', minWidth: 250, search: true, flex: 1, },
            { _text: '创建人', field: 'Creator', minWidth: 150, filter: true, align: 'left', flex: 1 },
            { _datetime: '创建时间', field: 'CreateTime', minWidth: 150, filter: true, align: 'left', flex: 1 },
            { _text: '状态', field: 'StatusName', minWidth: 150, filter: true, align: 'left', flex: 1 },
        ],
        onDoubleTap: ({ showDetail, refreshPage }, data) => {
            showDetail(props => <BatchSpecialLeaveDetail {...props} id={data.id} readOnly={true} />)
        }

    }
}

export default props => <Manager {...props} config={config} />